import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';

import DialogTitle from '../DialogTitle';
import locales from '../../../locales';
import { errorColor, errorContrastText, errorHoverColor } from '../../../theme';

const StyledDialog = withStyles(() => ({
  paper: {
    margin: '16px !important',
    overflowX: 'hidden',
    // На экранах меньше 600px (xs - только телефоны) используем отступы по 10px
    // Планшеты (sm: 600-959px) и десктоп (md+: ≥960px) используют стандартные отступы 16px
    '@media (max-width: 599px)': {
      maxWidth: 'calc(100% - 20px) !important',
      width: 'calc(100% - 20px) !important',
      margin: '10px !important',
    },
    '&.MuiDialog-paperWidthSm': {
      '@media (max-width: 599px)': {
        maxWidth: 'calc(100% - 20px) !important',
        width: 'calc(100% - 20px) !important',
        margin: '10px !important',
      },
    },
  },
}))(Dialog);

const DialogContent = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    minWidth: 415,
    minHeight: 160,
    maxWidth: '100%',
    overflowX: 'hidden',
    [theme.breakpoints.down(600)]: {
      minWidth: 'auto',
      padding: theme.spacing(2),
    },
  },
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    borderTop: `1px solid ${theme.palette.divider}`,
    margin: 0,
    padding: theme.spacing(),
    maxWidth: '100%',
    overflowX: 'hidden',
  },
}))(MuiDialogActions);

const ConfirmButton = withStyles(() => ({
  root: {
    color: errorContrastText,
    backgroundColor: errorColor,
    '&:hover': {
      backgroundColor: errorHoverColor,
    },
  },
}))(Button);

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

const LogoutConfirmationModal: React.FC<IProps> = ({
  isOpen,
  handleClose,
  handleConfirm,
}) => {
  return (
    <StyledDialog
      aria-labelledby="logout-dialog-title"
      open={isOpen}
      maxWidth="sm"
      fullWidth={false}
    >
      <DialogTitle onClose={handleClose}>
        {locales.t('common.logOut')}
      </DialogTitle>
      <DialogContent>
        <Typography gutterBottom style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}>
          Вы точно хотите выйти?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={handleClose}
          color="secondary"
        >
          Отмена
        </Button>
        <ConfirmButton
          variant="contained"
          onClick={handleConfirm}
        >
          Да
        </ConfirmButton>
      </DialogActions>
    </StyledDialog>
  );
};

export default LogoutConfirmationModal;
